import { AxiosRequestConfig } from "axios";
import { httpService } from "./HttpServices";
import { ApiResponse } from "./UserService";

export type OrphanType =
  | "deal_without_subscription"
  | "subscription_without_deal"
  | "deal_without_company"
  | "deal_without_contact"
  | "globalcustomer_without_match"
  | "deal_without_contract"
  | "deal_without_line_items"
  | "deal_without_customer_identity";

export interface OrphanMetadata {
  dealName?: string;
  companyName?: string;
  subscriptionId?: string;
  customerName?: string;
  customerEmail?: string;
  amount?: number;
  hubspotDealUrl?: string;
  missingCompany?: boolean;
  missingContact?: boolean;
  // ... other relevant display fields
}

export interface Orphan {
  _id: string;
  organizationId: string;
  type: OrphanType;
  hubspotDealId?: string;
  stripeSubscriptionId?: string;
  globalCustomerId?: string;
  metadata: OrphanMetadata;
  resolved: boolean;
  resolvedAt?: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface OrphansResponse {
  orphans: Orphan[];
  count: number;
}

export class OrphanService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = "/revsync";
  }

  /**
   * Get orphans with optional filters
   * @param type Filter by orphan type
   * @param resolved Filter by resolved status (true or false) - defaults to false
   */
  async getOrphans(
    filters?: {
      type?: OrphanType;
      resolved?: boolean;
    },
    config?: AxiosRequestConfig
  ): Promise<{ data: OrphansResponse; message: string }> {
    try {
      const params: Record<string, string> = {};
      if (filters?.type) {
        params.type = filters.type;
      }
      if (filters?.resolved !== undefined) {
        params.resolved = String(filters.resolved);
      }

      const response = await httpService.get<ApiResponse<OrphansResponse>>(
        `${this.baseUrl}/orphans`,
        {
          ...config,
          params,
        }
      );

      return {
        data: response.data,
        message: response.message,
      };
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message || "Failed to fetch orphans.";
      throw new Error(errorMessage);
    }
  }
}

export const orphanService = new OrphanService();
